import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    return time.toLocaleTimeString('en-US', { 
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = () => {
    return time.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 crt-scanlines wire-grid ${ 
        isScrolled
          ? 'bg-background/95 backdrop-blur-md border-b border-bondi-blue/50 shadow-[0_0_20px_rgba(0,149,182,0.3)]'
          : 'bg-background/80 backdrop-blur-sm border-b border-bondi-blue/20'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top bar - Y2K style info bar */}
        <div className="flex items-center justify-between py-2 border-b border-bondi-blue/20">
          <div className="flex items-center space-x-4 text-xs digital-text text-bondi-blue/70">
            <span className="crt-flicker">[SYSTEM ACTIVE]</span>
            <span className="hidden md:inline">|</span>
            <span className="hidden md:inline">{formatDate()}</span>
          </div>
          <div className="text-xs digital-text text-bondi-blue font-mono">
            {formatTime()}
          </div>
        </div>

        {/* Main navigation - minimal */}
        <div className="flex items-center justify-between h-12 relative px-4">
          {/* Left - Protocol/Site identifier */}
          <div className="text-xs digital-text text-bondi-blue/60">
            <span className="animate-pulse">●</span>
            <span className="ml-2">PROTOCOL://CARBON.PAGES</span>
          </div>

          {/* Right - Amazon Link */}
          <a
            href={process.env.REACT_APP_PURCHASE_URL || "https://www.amazon.com"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="outline"
              size="sm"
              className="border-bondi-blue/40 hover:border-bondi-blue hover:bg-bondi-blue/20 hover:text-bondi-blue transition-all digital-text text-xs hover:shadow-[0_0_10px_rgba(0,149,182,0.5)]"
            >
              <span className="mr-2">[BUY]</span>
              <ExternalLink className="h-3 w-3" />
            </Button>
          </a>
        </div>

        {/* Bottom status bar */}
        <div className="h-5 flex items-center justify-center border-t border-bondi-blue/20">
          <div className="flex items-center space-x-2 text-[10px] digital-text text-bondi-blue/50">
            <span>CONNECTION: ESTABLISHED</span>
            <span className="hidden md:inline">|</span>
            <span className="hidden md:inline">AUDIO: {isScrolled ? 'ACTIVE' : 'READY'}</span>
          </div>
        </div>
      </div>
    </nav>
  );
};